import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=6632ccec&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=6632ccec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6632ccec",
  null
  
)

export default component.exports